/* Progressive enhancement only; navigation and native details work without JS. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.cc-journey-nav a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(link.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  link.closest('nav').querySelectorAll('a').forEach(a => a.removeAttribute('aria-current'));
  link.setAttribute('aria-current', 'location');
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
  history.replaceState(null, '', link.hash);
});
